import req from "../http";

const login = {
  // 登入 後台
  managerLogin(params) {
    return req("post", "/auth/backstagelogin", params);
  },

  // 登入 應聘者
  candidateLogin(params) {
    return req("post", "/auth/login", params);
  },

  // 忘記密碼 (寄送驗證碼)
  forgetPassword(account) {
    return req("post", `/auth/user/ForgetPassword/${account}`, { account });
  },

  // 忘記密碼 - 變更密碼
  changePasswordByForgetPassword(params) {
    return req("post", "/auth/user/ChangePasswordByForgetPassword", params);
  },
};

export default login;